import { createFileRoute } from '@tanstack/react-router';

import DocumentsCategories from '@/modules/documents/pages/documents-categories';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/document-categories/',
)({
  head: () => ({
    meta: [{ title: 'Categorias de Documentos' }],
  }),
  component: DocumentsCategories,
});
